import axios from "axios";
import { toDate } from "date-fns";

const API_URL = process.env.REACT_APP_API_URL;
class Service {

  sendSms = async (vehicles: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}upcoming-service-sms`,
      data: vehicles,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}upcoming-service`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.upcomingService;
  };
  periodicSearch = async (fromDate: any, toDate: any ,code:any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}periodic-search`,
      params: {
        fromDate: `${fromDate} 00:00:00` ,
        toDate: `${toDate} 23:59:59`,
        data : code ,
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.periodicSearch;
  }
  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}upcoming-service-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.searchUpcomingService;
  };
  
  get = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}upcoming-service-sms`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.upcomingServiceSms;
  };
}


export default new Service();
